document.addEventListener('DOMContentLoaded', function () {
    // When user clicks on element with classes ".MuiBox-root.jss521.Avada-Preview__NavItem.Joy-WidgetVer3" block the default action
    // But element can be dynamically added later, so we use event delegation
    document.body.addEventListener('click', function (event) {
        if (event.target.matches('.MuiBox-root.jss521.Avada-Preview__NavItem.Joy-WidgetVer3')) {
            document.querySelector('.ecomsend__Popover__Widget__left')?.click()
        } else if (event.target.matches('button[data-js-product-add-to-cart-other]')) {
            event.preventDefault();
            document.querySelector('button[data-main-product-add-to-cart]')?.click();
        }
    });
})